import { getLevelArrayMetric as r } from "../index4.js";
import { getLevelServicesArea as t } from "../level-metrics/index30.js";
const v = (e) => r(e, t);
export {
  v as getLevelArrayServicesArea
};
//# sourceMappingURL=index17.js.map
